import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class Profession extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.name = model.name;
  }
}
